module.exports = __webpack_public_path__ + "static/img/bg1.0204d869.png";